import React, { Component } from 'react';
import { get } from 'lodash';
import { Typography, Button } from '@mui/material';

import Marker from './marker';
import Van from '../../../assets/other-wrangler.png';

const keyValueDisplay = (key, value) => (
  <div style={
    {
      margin: '5px 0px',
      paddingTop: '5px',
      paddingBottom: '10px',
    }
  }
  >
    <Typography style={
      {
        color: 'darkBlue',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }
    }
    >
      {key}
      :
      {value}
    </Typography>
  </div>
);

class WranglerMarker extends Component {
  get coordinates() {
    const { wrangler } = this.props;
    return get(wrangler, 'geo.geoJson.coordinates', null);
  }

  get markerProps() {
    const { wrangler } = this.props;
    const { coordinates } = this;

    return {
      position: { lat: coordinates[1], lng: coordinates[0] },
      key: wrangler._id,
      markerStyle: Van,
    };
  }

  renderExtraInfo() {
    const { wrangler, onClose } = this.props;
    const { firstName, lastName, phoneNumber } = wrangler;

    return (
      <div style={{ width: '300px' }}>
        {keyValueDisplay('Name', `${firstName} ${lastName}`)}
        {keyValueDisplay('Phone', `${phoneNumber}`)}
        <Button
          fullWidth
          color="primary"
          variant="contained"
          onClick={onClose}
        >
          Close
        </Button>
      </div>
    );
  }

  render() {
    const {
      wrangler, onClick, onClose, isSelected,
    } = this.props;
    if (this.coordinates) {
      return (
        <Marker
          key={wrangler._id}
          marker={this.markerProps}
          renderExtraInfo={() => this.renderExtraInfo()}
          onClick={() => onClick(wrangler)}
          onClose={onClose}
          isSelected={isSelected}
        />
      );
    } else {
      return null;
    }
  }
}

export default WranglerMarker;
